import { render, staticRenderFns } from "./notes.vue?vue&type=template&id=11c2840c&scoped=true"
import script from "./notes.vue?vue&type=script&lang=js"
export * from "./notes.vue?vue&type=script&lang=js"
import style0 from "./notes.vue?vue&type=style&index=0&id=11c2840c&prod&scoped=true&lang=css"
import style1 from "./notes.vue?vue&type=style&index=1&id=11c2840c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c2840c",
  null
  
)

export default component.exports